import { ApiUrls } from "appConstants/apis";
import { Tenant } from "models/tenant/Tenant";
import { BaseServices } from "./baseServices";

export class TenantService extends BaseServices<Tenant> {
	constructor() {
		super(Tenant);
	}

	getList(filters: any): any {
		try {
			return super
				.listPaginated(ApiUrls.tenants.getList, filters)
				.then((response) => response);
		} catch (error) {
			return undefined;
		}
	}

	getTenantDetails(id: string): any {
		return super.get(ApiUrls.tenants.getTenantDetails(id)).then((response) => {
			const tenant = Tenant.createFromResponse(response);
			return tenant;
		});
	}

	createTenant(data: any) {
		return super
			.create(ApiUrls.tenants.create, data)
			.then((response) => response);
	}

	editTenant(id: string, data: any) {
		return super
			.edit(ApiUrls.tenants.edit(id), data)
			.then((response) => response);
	}

	createResourcesFromListResponse(results: any[]): Tenant[] {
		return results.map((data) => Tenant.createFromResponse(data));
	}
}
